import type { PageVariable } from '@lighthouse/core'
import { useAtomCallback } from 'jotai/utils'
import { useCallback } from 'react'

import { pageVariableSchemasFamily } from '@/atoms/page/state'
import { useCurrentPageContext } from '@/contexts/PageContext'

/**
 * 生成页面数据变量名称
 *
 * @export
 * @returns {*}
 */
export function usePageDataQueryVariableLabel() {
    const { pageId } = useCurrentPageContext()

    return useAtomCallback(
        useCallback(
            (get, set, variable: PageVariable) => {
                const id = variable.pageDataQueryVariable?.id
                const itemId = variable.pageDataQueryVariable?.itemId
                if (!id || !itemId) {
                    return ''
                }

                const schemas = get(pageVariableSchemasFamily(pageId))
                const schema = schemas?.find(item => item.id === id)
                const variableItem = schema?.items.find(item => item.id === itemId)
                if (!variableItem) {
                    return ''
                }
                return `{${variableItem.name}}`
            },
            [pageId]
        )
    )
}
